module.exports = __webpack_public_path__ + "img/dropdown-icon.055bbf58.svg";